import { Component } from "@angular/core";
import { FieldType } from "@kre-form/core";

@Component({
  selector: "kreform-field-ion-image",
  template: `
    <ion-thumbnail>
      <img [src]="formControl.value" [ionKreFormAttributes]="field" />
    </ion-thumbnail>
  `,
})
export class KreFormFieldIonImage extends FieldType {}
